import { PalletType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum, IsNotEmpty } from "class-validator";

export class RackPositionRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    mastersCartons: number;
    @ApiProperty()
    loosePouches: number;
    // @ApiProperty({enum:Object.values(PalletType)})
    // @IsNotEmpty()
    // @IsEnum(PalletType)
    // palletType:PalletType;
  }
